import { Grid } from "@mui/material";
import { SummaryDto } from "../../app/models/summary/summaryDto";
import { useAppSelector } from "../../app/store/configureStore";
import React from "react";
import { GetSummaryColorCode } from "../../app/utils/util";

interface Props {
    legacySixYearSummaryData: SummaryDto[][] | null;
    isLegacyYearPartialyCompleted: boolean;
}

export default function LegacySummaryTable({ legacySixYearSummaryData, isLegacyYearPartialyCompleted }: Props) {
    const { legacyTitles } = useAppSelector(state => state.pcs);

    return <Grid container columns={18}>
        <Grid size={{ xs: 6, sm: 2.5 }} display={{ xs: 'block' }} sx={{ textAlign: 'center' }}>
            <b>{legacyTitles === null ? '' : legacyTitles[0]}</b>
        </Grid>

        <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
            <b>{legacyTitles === null ? '' : legacyTitles[2]}</b>
        </Grid>

        <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
            <b>{legacyTitles === null ? '' : legacyTitles[3]}</b>
        </Grid>

        <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
            <b>{legacyTitles === null ? '' : legacyTitles[4]}</b>
        </Grid>

        <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
            <b>{legacyTitles === null ? '' : legacyTitles[5]}</b>
        </Grid>

        <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
            <b>{legacyTitles === null ? '' : legacyTitles[6]}</b>
        </Grid>

        <Grid size={{ sm: 3 }} display={{ xs: 'none', sm: 'block' }} sx={{ textAlign: 'center' }}>
            <b>{legacyTitles === null ? '' : legacyTitles[7]}</b>
        </Grid>

        <Grid size={{ xs: 3 }} display={{ xs: 'block', sm: 'none' }}></Grid>

        <Grid size={{ xs: 9, sm: 2.5 }} display={{ xs: 'block' }} sx={{ textAlign: 'center' }}>
            <b>{legacyTitles === null ? '' : legacyTitles[8]}</b>
        </Grid>

        {legacySixYearSummaryData?.map((item: SummaryDto[], index: number) => (
            <React.Fragment key={index}>

                <Grid size={{ xs: 6, sm: 2.5 }}>
                    <Grid display={{ xs: 'block' }} sx={{ textAlign: 'center', paddingTop: '16px' }}>
                        {item[0].text}
                        {item[1].text.toLowerCase() === "true" ? "*" : ""}
                    </Grid>
                </Grid>

                <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[2].status.toUpperCase()),
                        textAlign: 'center', padding: 1
                    }}><b>{item[2].text.split('(')[0]}</b>({item[2].text.split('(')[1]}</Grid>
                </Grid>

                <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[3].status.toUpperCase()),
                        textAlign: 'center', padding: 1
                    }}><b>{item[3].text.split('(')[0]}</b>({item[3].text.split('(')[1]}</Grid>
                </Grid>

                <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[4].status.toUpperCase()),
                        textAlign: 'center', padding: 1
                    }}><b>{item[4].text.split('(')[0]}</b>({item[4].text.split('(')[1]}</Grid>
                </Grid>

                <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[5].status.toUpperCase()),
                        textAlign: 'center', padding: 1
                    }}><b>{item[5].text.split('(')[0]}</b>({item[5].text.split('(')[1]}</Grid>
                </Grid>

                <Grid size={{ sm: 2 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[6].status.toUpperCase()),
                        textAlign: 'center', padding: 1
                    }}><b>{item[6].text.split('(')[0]}</b>({item[6].text.split('(')[1]}</Grid>
                </Grid>

                <Grid size={{ sm: 3 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[7].status.toUpperCase()),
                        textAlign: 'center', padding: 1
                    }}>{item[7].text}</Grid>
                </Grid>

                <Grid size={{ xs: 3 }} display={{ xs: 'block', sm: 'none' }}></Grid>

                <Grid size={{ xs: 9, sm: 2.5 }} display={{ xs: 'block' }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[8].status.toUpperCase()),
                        textAlign: 'center', padding: 1, width: '90%'
                    }}>{item[8].text}</Grid>
                </Grid>
            </React.Fragment>
        ))}

        {legacySixYearSummaryData?.length === 0 &&
            <Grid size={{ xs: 18 }} sx={{ textAlign: 'center', padding: 5 }}>No records found.</Grid>
        }

        {legacySixYearSummaryData && legacySixYearSummaryData?.length > 0 && <>
            {isLegacyYearPartialyCompleted === true &&
                <Grid size={{ xs: 18 }} sx={{ paddingTop: 2, paddingLeft: 2 }}>* Partial Year Completed.</Grid>
            }

            <Grid size={{ xs: 18 }} display={{ xs: 'none', sm: 'block' }} sx={{ pl: 2, pt: 2 }}>
                Note: CPD Category requirements are displayed in brackets.
            </Grid>

            <Grid size={{ xs: 18 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 2 }}>
                <b>Please note: (Req.) = Required  - (Not Req.) =  Not Required.</b>
            </Grid>
        </>}

        <Grid size={{ xs: 18 }} sx={{ padding: 2 }}></Grid>
    </Grid>
}
